import { useState } from "react";
import "./TeacherPhoto.css";

function initialsFromName(name) {
  const parts = String(name || "")
    .trim()
    .split(/\s+/)
    .filter(Boolean);
  if (!parts.length) return "?";
  if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase();
  return `${parts[0][0]}${parts[parts.length - 1][0]}`.toUpperCase();
}

/**
 * Teacher image or a fixed-size styled placeholder (no broken /placeholder.jpg).
 * variant: "circle" (schedules) | "portrait" (faculty cards)
 */
export default function TeacherPhoto({
  picture,
  name,
  className = "",
  variant = "circle",
  style,
}) {
  const [failed, setFailed] = useState(false);
  const label = String(name || "Teacher").trim() || "Teacher";
  const showImage = Boolean(picture) && !failed;
  const photoClasses = ["teacher-photo", `teacher-photo--${variant}`]
    .filter(Boolean)
    .join(" ");

  if (variant === "circle") {
    const frameClasses = [
      "teacher-photo-frame",
      "teacher-photo-frame--circle",
      className,
    ]
      .filter(Boolean)
      .join(" ");

    if (showImage) {
      return (
        <span className={frameClasses} style={style}>
          <img
            className={`${photoClasses} teacher-photo--avatar-crop`}
            src={picture}
            alt={label}
            onError={() => setFailed(true)}
          />
        </span>
      );
    }

    return (
      <div
        className={`${frameClasses} ${photoClasses} teacher-photo--placeholder`}
        style={style}
        role="img"
        aria-label={label}
        title={label}
      >
        <span className="teacher-photo__initials" aria-hidden="true">
          {initialsFromName(label)}
        </span>
        <span className="teacher-photo__name">{label}</span>
      </div>
    );
  }

  const classes = [photoClasses, className].filter(Boolean).join(" ");

  if (showImage) {
    return (
      <img
        className={classes}
        style={style}
        src={picture}
        alt={label}
        onError={() => setFailed(true)}
      />
    );
  }

  return (
    <div
      className={`${classes} teacher-photo--placeholder`}
      style={style}
      role="img"
      aria-label={label}
      title={label}
    >
      <span className="teacher-photo__initials" aria-hidden="true">
        {initialsFromName(label)}
      </span>
      <span className="teacher-photo__name">{label}</span>
    </div>
  );
}
